/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse,
  DefineAgelessShortLinkRequest,
  DisplayAgelessShortLink,
  DisplayAgelessShortLinkCatalogResponse,
  DisplayAgelessWebsiteEmbedSettingsResponse,
  DisplayAllowAnonAgelessMarketingContext,
  DisplayValidatedAgelessMarketingSetupTokenResponse,
  GetSetupLinkScopeParams,
  GetSharedWebsiteEmbedSettingsParams,
  ProblemDetails,
  ResolveAgelessShortLinkParams,
  SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




/**
 * @summary What this link is scoped to: the platform and its current embed state, so the page can
show the setup wizard rather than the "an administrator must be signed in" notice.
 */
export const getSetupLinkScope = (
    params?: GetSetupLinkScopeParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayValidatedAgelessMarketingSetupTokenResponse>(
      {url: `/api/v1/ageless/marketing/setup-link`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetSetupLinkScopeQueryKey = (params?: GetSetupLinkScopeParams,) => {
    return [
    `/api/v1/ageless/marketing/setup-link`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetSetupLinkScopeQueryOptions = <TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(params?: GetSetupLinkScopeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSetupLinkScopeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetupLinkScope>>> = ({ signal }) => getSetupLinkScope(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSetupLinkScopeQueryResult = NonNullable<Awaited<ReturnType<typeof getSetupLinkScope>>>
export type GetSetupLinkScopeQueryError = ErrorType<ProblemDetails>


/**
 * @summary What this link is scoped to: the platform and its current embed state, so the page can
show the setup wizard rather than the "an administrator must be signed in" notice.
 */

export function useGetSetupLinkScope<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params?: GetSetupLinkScopeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSetupLinkScopeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Replaces the website-embed allowlist for this link's platform and enables the embed.
This is the only platform state a setup-link holder can change.
 */
export const setSetupLinkWebsiteEmbedAllowedOrigins = (
    setAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/marketing/setup-link/website-embed/allowed-origins`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest, signal
    },
      );
    }
  


export const getSetSetupLinkWebsiteEmbedAllowedOriginsMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, TError,{data: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, TError,{data: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest}, TContext> => {

const mutationKey = ['setSetupLinkWebsiteEmbedAllowedOrigins'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, {data: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest}> = (props) => {
          const {data} = props ?? {};

          return  setSetupLinkWebsiteEmbedAllowedOrigins(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetSetupLinkWebsiteEmbedAllowedOriginsMutationResult = NonNullable<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>>
    export type SetSetupLinkWebsiteEmbedAllowedOriginsMutationBody = SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest
    export type SetSetupLinkWebsiteEmbedAllowedOriginsMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Replaces the website-embed allowlist for this link's platform and enables the embed.
This is the only platform state a setup-link holder can change.
 */
export const useSetSetupLinkWebsiteEmbedAllowedOrigins = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, TError,{data: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>,
        TError,
        {data: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest},
        TContext
      > => {
      return useMutation(getSetSetupLinkWebsiteEmbedAllowedOriginsMutationOptions(options));
    }
    /**
 * @summary The practice's Ageless deployment checklist. The person doing the deployment is the one
who can honestly tick these off, which is why the link grants it.
 */
export const getSetupLinkDeploymentChecklistProgress = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse>(
      {url: `/api/v1/ageless/marketing/setup-link/deployment-checklist`, method: 'GET', signal
    },
      );
    }
  



export const getGetSetupLinkDeploymentChecklistProgressQueryKey = () => {
    return [
    `/api/v1/ageless/marketing/setup-link/deployment-checklist`
    ] as const;
    }

    
export const getGetSetupLinkDeploymentChecklistProgressQueryOptions = <TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSetupLinkDeploymentChecklistProgressQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>> = ({ signal }) => getSetupLinkDeploymentChecklistProgress(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSetupLinkDeploymentChecklistProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>>
export type GetSetupLinkDeploymentChecklistProgressQueryError = ErrorType<ProblemDetails>


/**
 * @summary The practice's Ageless deployment checklist. The person doing the deployment is the one
who can honestly tick these off, which is why the link grants it.
 */

export function useGetSetupLinkDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSetupLinkDeploymentChecklistProgressQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Marks a deployment checklist item complete on behalf of this link's holder.
 */
export const markSetupLinkChecklistItemAsCompleted = (
    itemSlug: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/marketing/setup-link/deployment-checklist/items/${itemSlug}/complete`, method: 'PUT', signal
    },
      );
    }
  


export const getMarkSetupLinkChecklistItemAsCompletedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, TError,{itemSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, TError,{itemSlug: string}, TContext> => {

const mutationKey = ['markSetupLinkChecklistItemAsCompleted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, {itemSlug: string}> = (props) => {
          const {itemSlug} = props ?? {};

          return  markSetupLinkChecklistItemAsCompleted(itemSlug,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type MarkSetupLinkChecklistItemAsCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>>
    
    export type MarkSetupLinkChecklistItemAsCompletedMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Marks a deployment checklist item complete on behalf of this link's holder.
 */
export const useMarkSetupLinkChecklistItemAsCompleted = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, TError,{itemSlug: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>,
        TError,
        {itemSlug: string},
        TContext
      > => {
      return useMutation(getMarkSetupLinkChecklistItemAsCompletedMutationOptions(options));
    }
    /**
 * @summary Clears a deployment checklist item on behalf of this link's holder.
 */
export const markSetupLinkChecklistItemAsIncomplete = (
    itemSlug: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/marketing/setup-link/deployment-checklist/items/${itemSlug}/incomplete`, method: 'PUT', signal
    },
      );
    }
  


export const getMarkSetupLinkChecklistItemAsIncompleteMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, TError,{itemSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, TError,{itemSlug: string}, TContext> => {

const mutationKey = ['markSetupLinkChecklistItemAsIncomplete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, {itemSlug: string}> = (props) => {
          const {itemSlug} = props ?? {};

          return  markSetupLinkChecklistItemAsIncomplete(itemSlug,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type MarkSetupLinkChecklistItemAsIncompleteMutationResult = NonNullable<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>>
    
    export type MarkSetupLinkChecklistItemAsIncompleteMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Clears a deployment checklist item on behalf of this link's holder.
 */
export const useMarkSetupLinkChecklistItemAsIncomplete = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, TError,{itemSlug: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>,
        TError,
        {itemSlug: string},
        TContext
      > => {
      return useMutation(getMarkSetupLinkChecklistItemAsIncompleteMutationOptions(options));
    }
    /**
 * @summary The short link for a flow and attribution, minted on this link's platform — the same
retrieve-or-define the signed-in wizard uses, so a web developer working from the setup
link gets the same code an admin would.
 */
export const defineSetupLinkAgelessShortLink = (
    defineAgelessShortLinkRequest: DefineAgelessShortLinkRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessShortLink>(
      {url: `/api/v1/ageless/marketing/setup-link/short-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: defineAgelessShortLinkRequest, signal
    },
      );
    }
  


export const getDefineSetupLinkAgelessShortLinkMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, TError,{data: DefineAgelessShortLinkRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, TError,{data: DefineAgelessShortLinkRequest}, TContext> => {

const mutationKey = ['defineSetupLinkAgelessShortLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, {data: DefineAgelessShortLinkRequest}> = (props) => {
          const {data} = props ?? {};

          return  defineSetupLinkAgelessShortLink(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DefineSetupLinkAgelessShortLinkMutationResult = NonNullable<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>>
    export type DefineSetupLinkAgelessShortLinkMutationBody = DefineAgelessShortLinkRequest
    export type DefineSetupLinkAgelessShortLinkMutationError = ErrorType<ProblemDetails>

    /**
 * @summary The short link for a flow and attribution, minted on this link's platform — the same
retrieve-or-define the signed-in wizard uses, so a web developer working from the setup
link gets the same code an admin would.
 */
export const useDefineSetupLinkAgelessShortLink = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, TError,{data: DefineAgelessShortLinkRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>,
        TError,
        {data: DefineAgelessShortLinkRequest},
        TContext
      > => {
      return useMutation(getDefineSetupLinkAgelessShortLinkMutationOptions(options));
    }
    /**
 * @summary Practice identity, subdomain, active clinics, and brand color for the Ageless Marketing
page when it is viewed without a session.
 */
export const getAgelessMarketingContext = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAllowAnonAgelessMarketingContext>(
      {url: `/api/v1/ageless/marketing/platforms/${platformId}/context`, method: 'GET', signal
    },
      );
    }
  



export const getGetAgelessMarketingContextQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/marketing/platforms/${platformId}/context`
    ] as const;
    }

    
export const getGetAgelessMarketingContextQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessMarketingContextQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessMarketingContext>>> = ({ signal }) => getAgelessMarketingContext(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgelessMarketingContextQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessMarketingContext>>>
export type GetAgelessMarketingContextQueryError = ErrorType<ProblemDetails>


/**
 * @summary Practice identity, subdomain, active clinics, and brand color for the Ageless Marketing
page when it is viewed without a session.
 */

export function useGetAgelessMarketingContext<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgelessMarketingContextQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary The platform's current website-embed state, as the login-free marketing page renders it.
Carries only the enabled flag and the practice's own approved website list — no billing,
contact, or patient-derived data.
 */
export const getSharedWebsiteEmbedSettings = (
    platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessWebsiteEmbedSettingsResponse>(
      {url: `/api/v1/ageless/marketing/platforms/${platformId}/website-embed-settings`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetSharedWebsiteEmbedSettingsQueryKey = (platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams,) => {
    return [
    `/api/v1/ageless/marketing/platforms/${platformId}/website-embed-settings`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetSharedWebsiteEmbedSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSharedWebsiteEmbedSettingsQueryKey(platformId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>> = ({ signal }) => getSharedWebsiteEmbedSettings(platformId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSharedWebsiteEmbedSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>>
export type GetSharedWebsiteEmbedSettingsQueryError = ErrorType<ProblemDetails>


/**
 * @summary The platform's current website-embed state, as the login-free marketing page renders it.
Carries only the enabled flag and the practice's own approved website list — no billing,
contact, or patient-derived data.
 */

export function useGetSharedWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSharedWebsiteEmbedSettingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary The catalog campaign short links (giveaway kit, SMS blast, onboarding shortcut) spelled out
for a practice — every channel crossed with every flow, each with its fixed code and both
URLs. This is what the HubSpot campaign kit renders instead of composing UTMs itself.
 */
export const getAgelessShortLinkCatalog = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessShortLinkCatalogResponse>(
      {url: `/api/v1/ageless/marketing/platforms/${platformId}/short-links/catalog`, method: 'GET', signal
    },
      );
    }
  



export const getGetAgelessShortLinkCatalogQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/marketing/platforms/${platformId}/short-links/catalog`
    ] as const;
    }

    
export const getGetAgelessShortLinkCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessShortLinkCatalogQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>> = ({ signal }) => getAgelessShortLinkCatalog(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgelessShortLinkCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>>
export type GetAgelessShortLinkCatalogQueryError = ErrorType<unknown>


/**
 * @summary The catalog campaign short links (giveaway kit, SMS blast, onboarding shortcut) spelled out
for a practice — every channel crossed with every flow, each with its fixed code and both
URLs. This is what the HubSpot campaign kit renders instead of composing UTMs itself.
 */

export function useGetAgelessShortLinkCatalog<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgelessShortLinkCatalogQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Where a short-domain path sends the patient. The aglss.ai Vercel project rewrites
`/{prefix}{slug}/{code}` here with the flow named by the prefix; the answer is a 307 to
the tagged Ageless URL, or 404 when nothing matches, so a mistyped code never becomes
untagged traffic on the landing page.
 */
export const resolveAgelessShortLink = (
    params?: ResolveAgelessShortLinkParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<unknown>(
      {url: `/api/v1/ageless/marketing/short-links/resolve`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getResolveAgelessShortLinkQueryKey = (params?: ResolveAgelessShortLinkParams,) => {
    return [
    `/api/v1/ageless/marketing/short-links/resolve`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getResolveAgelessShortLinkQueryOptions = <TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(params?: ResolveAgelessShortLinkParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveAgelessShortLinkQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveAgelessShortLink>>> = ({ signal }) => resolveAgelessShortLink(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData> & { queryKey: QueryKey }
}

export type ResolveAgelessShortLinkQueryResult = NonNullable<Awaited<ReturnType<typeof resolveAgelessShortLink>>>
export type ResolveAgelessShortLinkQueryError = ErrorType<void | ProblemDetails>


/**
 * @summary Where a short-domain path sends the patient. The aglss.ai Vercel project rewrites
`/{prefix}{slug}/{code}` here with the flow named by the prefix; the answer is a 307 to
the tagged Ageless URL, or 404 when nothing matches, so a mistyped code never becomes
untagged traffic on the landing page.
 */

export function useResolveAgelessShortLink<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params?: ResolveAgelessShortLinkParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getResolveAgelessShortLinkQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




